module.exports = __webpack_public_path__ + "static/media/mask-group-1.3179ee19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-1.png
// module id = 1293
// module chunks = 1